/* loaded by smart-asset */
export default require("./caret-up-solid~bbOwPNzS.svg")